export default {"src":"/_next/static/media/RegularCheckup.cab1d3ae.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};